import { Component, OnInit, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { MdmPerson } from '../../../models/contact-mdm-person.model';
import { TokenResponse } from '../../../models/contact-token.model';
import { ContactDataService } from '../../../services/contact-data-service';
import { ContactVerificationService } from '../../../services/contact-verification-service';
import { ContactMappingService } from '../../../services/contact-mapping-service';
import { OedsPerson } from '../../../models/contact-oeds-person.model';
import { ContactVerificationFailComponent } from './contact-verification-fail/contact-verification-fail.component';
import { ContactVerificationSuccessComponent } from './contact-verification-success/contact-verification-success.component';
import { ContactVerificationReviewSubmitComponent } from './contact-verification-review-submit/contact-verification-review-submit.component';
import { ContactVerificationPhoneComponent } from './contact-verification-phone/contact-verification-phone.component';
import { ContactVerificationAddressComponent } from './contact-verification-address/contact-verification-address.component';
import { ContactVerificationEmailOfficeComponent } from './contact-verification-email-office/contact-verification-email-office.component';
import { ContactVerificationEmailsComponent } from './contact-verification-emails/contact-verification-emails.component';
import { ContactVerificationIntroductionComponent } from './contact-verification-introduction/contact-verification-introduction.component';
import { ContactVerificationStepperComponent } from './contact-verification-stepper/contact-verification-stepper.component';

@Component({
    selector: 'app-contact-verification-container',
    templateUrl: './contact-verification-container.component.html',
    styleUrls: ['./contact-verification-container.component.css'],
    imports: [NgxSpinnerModule, ContactVerificationStepperComponent, ContactVerificationIntroductionComponent, ContactVerificationEmailsComponent, ContactVerificationEmailOfficeComponent, ContactVerificationAddressComponent, ContactVerificationPhoneComponent, ContactVerificationReviewSubmitComponent, ContactVerificationSuccessComponent, ContactVerificationFailComponent]
})
export class ContactVerificationContainerComponent implements OnInit {
  private cDataService = inject(ContactDataService);
  private cMapservice = inject(ContactMappingService);
  cService = inject(ContactVerificationService);
  private route = inject(ActivatedRoute);
  private spinner = inject(NgxSpinnerService);

  isDataSyncCompleted = false;
  useruid: any;
  oneTimeToken: string = '';
  readonly stepcount = input<number>(undefined);
  constructor() {

    this.oneTimeToken = encodeURIComponent(this.route.snapshot.queryParams['token']);
    this.cService.contactVerificationFailed = this.cService.contactVerificationFailed || (this.route.snapshot.url.join('/').indexOf('/error') !== -1);
    if (environment.debug) console.log("In ArmWebComponent: In ContactVerificationContainerComponent.constructor(): this.route.snapshot.url.join('/')=", this.route.snapshot.url.join('/'), 
                ",this.cService.contactVerificationFailed=", this.cService.contactVerificationFailed);

    if (this.route.snapshot.queryParams['token'] == undefined) {
      if (environment.debug) console.log("In ArmWebComponent: In ContactVerificationContainerComponent.constructor(): this.route.snapshot.queryParams['token']=", 
                  this.route.snapshot.queryParams['token']);
      this.cService.isFromHeadIcon = true;      
    }
    this.decodeSAMLToken()
    //Call Get APIs when intial page load not from back button
     
  }

  ngOnInit(): void {
    if (this.cService.stepperList == null) {
      this.cDataService.getOrgRoles().subscribe({
        next: (rolesResponse: []) => {
          if (rolesResponse.length == 0) {
            //If Office Email not Empty show office step
            if (this.cService.hasOfficeEmail) {
              this.cService.isUserOrgMappingExist = false;
              this.cService.stepperList = {
                items: [
                  { label: "Introduction", completed: false, selected: true, current: true, },
                  { label: "Personal Email", completed: false, selected: false, current: false, },
                  { label: "Office Email", completed: false, selected: false, current: false },
                  { label: "Address", completed: false, selected: false, current: false, },
                  { label: "Phone", completed: false, selected: false, current: false, },
                  { label: "Review and Submit", completed: false, selected: false, current: false, }
                ]
              }
            }
            else {
              this.cService.isUserOrgMappingExist = false;
              this.cService.stepperList = {
                items: [
                  { label: "Introduction", completed: false, selected: true, current: true, },
                  { label: "Personal Email", completed: false, selected: false, current: false, },
                  { label: "Address", completed: false, selected: false, current: false, },
                  { label: "Phone", completed: false, selected: false, current: false, },
                  { label: "Review and Submit", completed: false, selected: false, current: false, }
                ]
              }
            }
          }
          else {
            this.cService.isUserOrgMappingExist = true;
            this.cService.stepperList = {
              items: [
                { label: "Introduction", completed: false, selected: true, current: true, },
                { label: "Personal Email", completed: false, selected: false, current: false, },
                { label: "Office Email", completed: false, selected: false, current: false },
                { label: "Address", completed: false, selected: false, current: false, },
                { label: "Phone", completed: false, selected: false, current: false, },
                { label: "Review and Submit", completed: false, selected: false, current: false, }
              ]
            }
          }

          //If it's annual verification navigate to Review and Submit Page direclty
          if (this.cService.tokenDtls.annualVerification === "True") {
            // stepCount is set to Review and Submit which can be 5 or 6
            // so derive it from the stepperList length instead - kevin.low 05/13/25
            this.cService.stepCount = this.cService.stepperList.items.length;
            this.cService.setStep('Review and Submit');
          }
          else
            // If it's not annual verification, do the same as first time verification - kevin.low 06/07/24
            this.cService.stepCount = 1;
        },
        error: (error) => {
          this.cService.contactVerificationFailed = true;
        }
      });
    }
  }
  onUpdatedStepcount(value: number): void {
    this.cService.stepCount = value;
  }  

  //Decode SAML token and Get Person Object from MDM
  decodeSAMLToken() {
    this.spinner.show();
    this.cDataService.decodeToken(this.oneTimeToken).subscribe({
      next: (tdetails: TokenResponse) => {
        this.cService.oaksId = tdetails.oaksId;
        this.useruid = tdetails.userUuid;
        this.cService.tokenDtls = tdetails;
        this.syncDataToMdm();
        this.getMdmPersonDetails();
        this.spinner.hide();
      },
      error: (error) => {
        this.cService.contactVerificationFailed = true;
        this.spinner.hide();
      }
    });
  }
 //API call to Get person Object from MDM
  getMdmPersonDetails() {
      this.spinner.show();  
      var articles = ["IdentifierList","EmailList", "AddressList", "PhoneList", "RoleMemberList"];
      this.cDataService.getMDMPersonDtls(this.useruid, articles).subscribe({
        next: (mdmPerson: MdmPerson) => {
          this.cService.personkey = mdmPerson[0].key;
          if (this.cService.isFromHeadIcon == true) {
            this.cService.tokenDtls.userUuid = this.useruid;
            this.cService.tokenDtls.oaksId = mdmPerson[0].oaksIds[0].oaksId;
            this.cService.tokenDtls.ohidEmail = mdmPerson[0].oaksIds[0].ohidEmailAddress;
            this.cService.tokenDtls.firstTimeVerification = "True";
          }

          if (environment.debug) console.log("MDM Person Object:" + JSON.stringify(mdmPerson));

          this.cService.assignDefaultOedsPerson();
          //Code to map MDM person object  to oeds person object
          this.cMapservice.mapContactDtlsModel(mdmPerson[0], this.cService.oedsPerson);
          this.cService.oedsPersonCopy = this.cService.oedsPerson;
          //If Office Emails not empty from MDM
          let officeEmails = this.cService.filterEmailByType(this.cMapservice.getOedsEmailTypeKey('Office'), this.cService.oedsPersonCopy.emailList);
          if (officeEmails?.length>0) {
            this.cService.hasOfficeEmail = true;
          }

          if (environment.debug) console.log("OEDS Person Object:" + JSON.stringify(this.cService.oedsPerson));
          this.getIsUserTiedToMultipleOrgs(mdmPerson[0].organizationRoleMemberList);
                   
          this.isDataSyncCompleted = true;
          if (environment.debug) console.log("Contact Details Object:" + JSON.stringify(this.cService));
        },
        error: (error) => {
          this.cService.contactVerificationFailed = true;
        }
      });
  }  
  getIsUserTiedToMultipleOrgs(orgRoleMemberList) {
    const uniqueOrgList = [...new Set(orgRoleMemberList.map(item => item.organizationKey))];
    if (uniqueOrgList.length !== 0)
      this.cService.isOfficeEmailRequired = true;
    if (uniqueOrgList.length > 1) {
      //this.cService.isUserOrgMappingExist = true;
      this.cService.isUserTiedToMutipleOrgs = true;
    }
    else {
      //this.cService.isUserOrgMappingExist = false;
      this.cService.isUserTiedToMutipleOrgs = false;
    }
  }
  syncDataToMdm() {
    let userUuid = this.cService.tokenDtls.userUuid
    this.cDataService.syncDataToMdm(userUuid).subscribe({
      next: (response) => {
      },
      error: (errorobj) => console.error("In syncDataToMdm: ", errorobj.error)
    })
  }
}
